<sub-header [includeContextHelp]="true" [isModal]="true" [windowHash]=windowHash></sub-header>
<p-scrollPanel [style]="{width: '100%', height: '60vh'}" styleClass="custombar1">
  <formPlyca #frmAward [formConfig]="formConfig" *ngIf="formConfig"></formPlyca>
</p-scrollPanel>